export default {
    meta: {
        title: 'PMS 后台登录中',
    },
};
